var exports = {
  "Qs": "GuildOwnershipWarningModal.module__content___ZHRDaV",
  "OW": "GuildOwnershipWarningModal.module__guildList___ZHRDaV",
  "RZ": "GuildOwnershipWarningModal.module__guildItem___ZHRDaV",
  "$f": "GuildOwnershipWarningModal.module__guildIcon___ZHRDaV",
  "OA": "GuildOwnershipWarningModal.module__guildInfo___ZHRDaV",
  "J5": "GuildOwnershipWarningModal.module__guildName___ZHRDaV",
  "i1": "GuildOwnershipWarningModal.module__remainingCount___ZHRDaV",
  "BK": "GuildOwnershipWarningModal.module__helpText___ZHRDaV",
};

module.exports = exports;
